<div class="padding margin-top">
  <div class="flex-container">
    <h1 class="left-box">{{ 'bundles.bundles' | transloco }}</h1>
    <span class="spacer"></span>
    <button mat-fab [matTooltip]="'bundles.addBundle' | transloco" [routerLink]="['add']"
      [attr.aria-label]="'bundles.buttonThatAddsNewBundle' | transloco" color="accent">
      <mat-icon>add</mat-icon>
    </button>
  </div>
  <div class="flex-container">
    <p class="intro-text padding-bottom-25">{{ 'bundles.aBundleCanContainGroupsOf' | transloco }}</p>
  </div>
  <app-bundles-filter></app-bundles-filter>
  <div class="table-container padding-top">
    <table mat-table matSort [dataSource]="this.repo.resource$" multiTemplateDataRows
      class="mat-elevation-z0" (matSortChange)="sort($event)"
      [class.table-loading]="this.repo.loading$ | async">

      <!-- Invoice ID -->
      <ng-container matColumnDef="name">
        <th mat-header-cell *matHeaderCellDef> {{ 'common.labels.name' | transloco }} </th>
        <td mat-cell *matCellDef="let bundle"> {{bundle.name}} </td>
      </ng-container>

      <!-- Invoice ID -->
      <ng-container matColumnDef="description">
        <th mat-header-cell *matHeaderCellDef> {{ 'common.labels.description' | transloco }} </th>
        <td mat-cell *matCellDef="let bundle"> {{bundle.description}} </td>
      </ng-container>

      <!-- Date Paid -->
      <ng-container matColumnDef="added">
        <th mat-header-cell *matHeaderCellDef> {{ 'common.labels.added' | transloco }} </th>
        <td mat-cell *matCellDef="let bundle"> {{bundle.added | localizedDate:'yyyy-MM-dd'}} </td>
      </ng-container>

      <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
      <tr mat-row *matRowDef="let row; columns: displayedColumns;" [routerLink]="[row.id]">
      </tr>
    </table>
  </div>
  @if ((this.repo.resourceCount$ | async) ?? 0 > 0) {
    <mat-paginator [pageSize]="this.repo.pageSize$ | async"
      [length]="this.repo.resourceCount$ | async" [pageIndex]="this.repo.pageNum$ | async"
    [pageSizeOptions]="[10, 25, 50]" (page)="page($event)"></mat-paginator>
  }
</div>